<template>
<div>
    <Spinner v-if="loading">Processing transaction...</Spinner>
    <div v-else class="row verifyrow center">
        <p class="enterotp" v-html="data.details.message"></p>

        <div class="verificationform">
            <input :type="showNum ? (isOTP ? 'number' : 'password') : 'text'" pattern="[0-9]{1}" style="margin: 0 !important;width: 100% !important;text-align:center;font-size: 35px !important;" v-model="trx_otp" :maxlength="10" autocomplete="off" minlength="4" autofocus required @keyup.enter="submitOtp" id="otpInput" ref="otpInput" @focus="isFocus = true" @blur="isFocus = false" :style="{ borderColor: (isFocus ? appColor : '#e4e4e4')  }" />
        </div>

        <div v-if="isOTP && data.details.message.toLowerCase().includes(' otp ')">
            <small class="dnot">Didn't receive an OTP?</small>
            <p class="resend pointer" @click.prevent="resendOtp">Resend OTP</p>
        </div>

        <button :disabled="trx_otp.length < 4" type="button" class="submit" @click.prevent="submitOtp" @keyup.enter="submitOtp">Submit</button>

        <div class="col-12 px-0 mt-3">
            <div v-if="!loading" class="form-group text-center mb-0">
                <a href="javascript:void(0)" class="text-tiny" @click.prevent="tryAgain">Change card</a>
            </div>
        </div>

    </div>
</div>
</template>

<script>
/* eslint-disable */
import axios from 'axios';
import Spinner from './includes/Spinner.vue';

export default {
    name: 'otp',
    props: ['data', 'appColor', 'client_info', 'button_color'],
    components: {
        Spinner
    },
    created() {
        if (this.data.details.message && this.data.details.message.includes('name'))
            this.showNum = false
        else
            this.showNum = true;

    },
    watch: {
        trx_otp(newVal) {
            if (this.errors.trx_otp) {
                this.errors.trx_otp = false;
                this.trx_otp = newVal;
            }
        },
        isFocus(newVal) {
            if (newVal)
                this.focusColor = this.appColor

        }
    },
    data() {
        return {
            trx_otp: '',
            otp_error_message: '',
            isFocus: true,
            isOTP: true,
            focusColor: '',
            showNum: true,
            loading: false,
            errors: {
                trx_otp: false,
            }
        }
    },

    mounted() {
        this.trx_otp='';
        this.$emit('handleTitle', this.$store.state.provider ? this.$store.state.provider.option : 'Verification');
    },
    methods: {
        tryAgain() {
            const newRef = `${this.$store.state.parentTransRef}-${this.$generateTransactionRef(4)}`;
            this.$store.dispatch('transRef', newRef);
            this.$store.dispatch('isFailed', true);
            this.$parent.changeComponent('CardPayment');
            this.loading = false;
        },

        validate() {
            if (this.trx_otp.length <= 0) {
                this.errors.trx_otp = true;
                this.otp_error_message = "Please supply OTP code.";
                this.$refs.otpInput.focus();
                return;
            }

            this.submitOtp();
        },

        resendOtp(){



        },
        submitOtp() {

            let payload = {
                    request_ref: this.$generateRequestRef(),
                    request_type: this.$store.state.payload.request_type,
                    auth: {
                        secure: this.trx_otp,
                        // auth_provider: "Quickteller"
                    },
                    transaction: {
                        transaction_ref: this.$store.state.transRef
                    }
                },
                data2 = {
                    endpoint: 'validate',
                    api_key: this.$store.state.api_key,
                    payload,
                },
                dataPayload = this.$generateToken(data2);

            this.loading = true;

            axios.post(this.baseApiUrl + "v2/onepipe/js", {
                    data: dataPayload,
                }, {
                    timeout: this.API_CALL_TIMEOUT, // 3 mins
                    Authorization: `Bearer ${this.$store.state.payload.api_key}`
                }).then( ({data}) => {
                    
                    let hash = data.data,
                        res = this.$decodeToken(hash),
                        status = res.status.toLowerCase(),
                        message = res.message,
                        responseData = res.data;
                    window.raw = JSON.stringify(res);
                    
                    this.trx_otp='';
                    
                    if(status == 'pendingvalidation'){
                        this.isOTP = false;
                    }

                    this.loading = false;
                    if (status == "successful") {
                        this.$parent.changeComponent('Status', {
                            reference: payload.transRef,
                            data: responseData,
                            type: 'Successful',
                            message: message || res.data.message
                        });

                    } else if (['pendingvalidation','waitingforotp'].includes(status)) {
                        this.$parent.changeComponent('OTP', {
                            message: message
                        });

                    } else {
                        window.failedFromStart = false;
                        window.failedFromStartMessage = res.message;
                        this.$router.push('/v2/mtn/warning');
                    }
                })
                .catch(error => {
                    window.failedFromStartMessage = error;
                    window.failedFromStart = false;
                    this.$router.push('/v2/mtn/warning');
                })
        }
    }
};
</script>
